import { render, staticRenderFns } from "./propertyDelivery.vue?vue&type=template&id=006e82a2&scoped=true&"
import script from "./propertyDelivery.vue?vue&type=script&lang=js&"
export * from "./propertyDelivery.vue?vue&type=script&lang=js&"
import style0 from "./propertyDelivery.vue?vue&type=style&index=0&id=006e82a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e82a2",
  null
  
)

export default component.exports